// affiliate code

(function() {
    'use strict';

    // --- Configuration ---
    const AFFILIATE_PARAM_NAME = 'ref';
    const LOCAL_STORAGE_KEY = 'shopifyAffiliateId';
    const CART_ATTRIBUTE_NAME = 'affiliate_id'; // This will become "attributes[affiliate_id]"
    const THANK_YOU_PAGE_PATH_CHECK = '/checkout/thank_you';
    let attributeAddedThisSession = false; // Flag to prevent multiple AJAX calls if not needed

    /**
     * Gets the value of a specified URL query parameter.
     * @param {string} paramName - The name of the query parameter.
     * @returns {string|null} The value of the parameter or null if not found.
     */
    function getQueryParam(paramName) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(paramName);
    }

    /**
     * Stores the affiliate ID in localStorage.
     * @param {string} affiliateId - The affiliate identifier to store.
     */
    function storeAffiliateId(affiliateId) {
        if (!affiliateId) return;
        try {
            // Only store if it's different from what's already there or if it's new
            // This also resets our "added this session" flag if the ID changes
            const currentStoredId = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (currentStoredId !== affiliateId) {
                localStorage.setItem(LOCAL_STORAGE_KEY, affiliateId);
                console.log(`Affiliate ID "${affiliateId}" stored/updated in localStorage.`);
                attributeAddedThisSession = false; // Reset flag if ID changes
            } else {
                console.log(`Affiliate ID "${affiliateId}" already stored and matches. No change.`);
            }
        } catch (e) {
            console.error('Error storing affiliate ID in localStorage:', e);
        }
    }

    /**
     * Retrieves the affiliate ID from localStorage.
     * @returns {string|null} The stored affiliate ID or null if not found/error.
     */
    function getStoredAffiliateId() {
        try {
            return localStorage.getItem(LOCAL_STORAGE_KEY);
        } catch (e) {
            console.error('Error retrieving affiliate ID from localStorage:', e);
            return null;
        }
    }

    /**
     * Clears the affiliate ID from localStorage.
     */
    function clearStoredAffiliateId() {
        try {
            const removedId = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (removedId) {
                localStorage.removeItem(LOCAL_STORAGE_KEY);
                console.log(`Affiliate ID "${removedId}" cleared from localStorage.`);
                attributeAddedThisSession = false; // Reset flag
            }
        } catch (e) {
            console.error('Error clearing affiliate ID from localStorage:', e);
        }
    }

    function addAffiliateAttributeToCartViaAjax(affiliateId) {
        if (!affiliateId || attributeAddedThisSession) {
            if (attributeAddedThisSession) {
                console.log('Affiliate attribute already attempted/added this session for ID:', affiliateId);
            }
            return;
        }

        const data = {
            attributes: {}
        };
        data.attributes[CART_ATTRIBUTE_NAME] = affiliateId;


        fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest' 
            },
            body: JSON.stringify(data) 
        })
        .then(response => response.json())
        .then(cart => {
            console.log(`Cart attribute "${CART_ATTRIBUTE_NAME}" set to "${affiliateId}" via AJAX. Cart state:`, cart);
            attributeAddedThisSession = true; // Mark as added for this ID in this session

        })
        .catch((error) => {
            console.error(`Error updating cart attributes for affiliate ID "${affiliateId}":`, error);

        });
    }

    // --- Main Execution ---

    document.addEventListener('DOMContentLoaded', function() {
        // 1. Check for affiliate parameter in URL and store it
        const affiliateIdFromUrl = getQueryParam(AFFILIATE_PARAM_NAME);
        if (affiliateIdFromUrl) {
            storeAffiliateId(affiliateIdFromUrl);
        }


        const storedAffiliateId = getStoredAffiliateId();


        if (window.location.pathname.includes(THANK_YOU_PAGE_PATH_CHECK) ||
            (typeof Shopify !== 'undefined' && Shopify.Checkout && Shopify.Checkout.isOrderStatusPage === true) ) {
            clearStoredAffiliateId();
        } else if (storedAffiliateId) {

            addAffiliateAttributeToCartViaAjax(storedAffiliateId);
        }
    });
})();





// ═══════════════════════════════════════════════════════════════════
// Peptides cart logic + bundle-app handler
// (was appended to assets/utilities.js, now lives here)
// ═══════════════════════════════════════════════════════════════════
// peptides

(() => {

    const getId = (gid) => Number(gid.split('/').pop());

    const TRIGGER_ADDON_VARIANT_IDS = [
      "gid://shopify/ProductVariant/47580950036721",
      "gid://shopify/ProductVariant/47580950069489",
      "gid://shopify/ProductVariant/47580950102257",
      "gid://shopify/ProductVariant/47580950135025",
      "gid://shopify/ProductVariant/47580950167793",
      "gid://shopify/ProductVariant/47580950200561",
      "gid://shopify/ProductVariant/47580950233329",
      "gid://shopify/ProductVariant/47580950266097",
      "gid://shopify/ProductVariant/47580950298865",
      "gid://shopify/ProductVariant/47580950331633",
    ].map(getId);

    const WEIGHT_LOSS_PROGRAM_VARIANT_IDS = [
      "gid://shopify/ProductVariant/47610566115569",
      "gid://shopify/ProductVariant/47610566148337",
      "gid://shopify/ProductVariant/47580921463025",
      "gid://shopify/ProductVariant/47580921495793",
    ].map(getId);

    const PHYSICIAN_FEE_ADD_VARIANT_ID = getId("gid://shopify/ProductVariant/47580962980081");

    let isProcessing = false;

    async function checkAndModifyCart() {
      
      if (isProcessing) return;
      isProcessing = true;

      try {
        
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        let triggerAddonPresent = false;
        let programPresent = false;
        let physicianFeeLines = [];
 

        
        for (const item of cart.items) {
          if (TRIGGER_ADDON_VARIANT_IDS.includes(item.variant_id)) {
            triggerAddonPresent = true;
          }
          if (WEIGHT_LOSS_PROGRAM_VARIANT_IDS.includes(item.variant_id)) {
            programPresent = true;
          }
          if (item.variant_id === PHYSICIAN_FEE_ADD_VARIANT_ID) {
            physicianFeeLines.push(item);
          }
        }

        let changesMade = false;

        // Remove ALL physician fees if no peptides or program is present
        if ((!triggerAddonPresent || programPresent) && physicianFeeLines.length > 0) {
          console.log("Removing Physician Fee...");
          for (const item of physicianFeeLines) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            });
          }
          changesMade = true;
        }

        // Add physician fee if peptides are present and none exists yet
        else if (triggerAddonPresent && !programPresent && physicianFeeLines.length === 0) {
          console.log("Adding Physician Fee...");
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{ id: PHYSICIAN_FEE_ADD_VARIANT_ID, quantity: 1 }]
            })
          });
          changesMade = true;
        }

        // Cap at 1: if duplicates exist, keep the first and remove the rest
        else if (physicianFeeLines.length > 1) {
          console.log("Removing duplicate Physician Fees...");
          for (let i = 1; i < physicianFeeLines.length; i++) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: physicianFeeLines[i].key, quantity: 0 })
            });
          }
          if (physicianFeeLines[0].quantity > 1) {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: physicianFeeLines[0].key, quantity: 1 })
            });
          }
          changesMade = true;
        }

        // Single physician fee but quantity > 1, cap it
        else if (physicianFeeLines.length === 1 && physicianFeeLines[0].quantity > 1) {
          console.log("Capping Physician Fee quantity to 1...");
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: physicianFeeLines[0].key, quantity: 1 })
          });
          changesMade = true;
        }


        if (changesMade) {
          window.location.reload(); 
        }

      } catch (error) {
        console.error("Physician Fee Script Error:", error);
      } finally {
        isProcessing = false;
      }
    }

    document.addEventListener('DOMContentLoaded', checkAndModifyCart);

    setInterval(checkAndModifyCart, 60000);

    const originalFetch = window.fetch;
    window.fetch = async function () {
      const response = await originalFetch.apply(this, arguments);
      
      if (arguments[0] && (typeof arguments[0] === 'string') && 
         (arguments[0].includes('/cart/add') || arguments[0].includes('/cart/change'))) {

         setTimeout(checkAndModifyCart, 300);
      }
      
      return response;
    };

    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function() {
        this.addEventListener("load", function() {
            if (this.responseURL && (this.responseURL.includes("/cart/add") || this.responseURL.includes("/cart/change"))) {
                setTimeout(checkAndModifyCart, 500);
            }
        });
        open.apply(this, arguments);
    };

  })();






// fixing subscription issue notifying the bundle app


let isAutoChecking = false;

document.addEventListener('change', function (e) {
  if (isAutoChecking) return;

  if (
    e.target.matches(
      '.variant-picker__form input[type="radio"]'
    ) &&
    e.target.checked
  ) {
    console.log('Checked input:', e.target);
    console.log('Value:', e.target.value);
    console.log('Variant ID:', e.target.dataset.variantId);

    const radios = document.querySelectorAll(
      'input[type="radio"][name="bundleapp-plan-selector-group"]'
    );

    const firstUnchecked = Array.from(radios).find(
      radio => !radio.checked && !radio.disabled
    );

    if (firstUnchecked) {
      isAutoChecking = true;

      setTimeout(() => {
        firstUnchecked.checked = true;

        // Notify Shopify / Bundle app
        firstUnchecked.dispatchEvent(
          new Event('change', { bubbles: true })
        );

        console.log('Auto-checked after 0.5s:', firstUnchecked);

        isAutoChecking = false;
      }, 800);
    }
  }
});
// ═══════════════════════════════════════════════════════════════════
// Collection list-view toggle
// (was inline in sections/main-collection.liquid)
// ═══════════════════════════════════════════════════════════════════



  // List view logic

  /* --- List View Toggle Logic --- */
  document.addEventListener('DOMContentLoaded', () => {
    function initViewToggle() {
      const container = document.querySelector('.collection-wrapper');
      const radios = document.querySelectorAll('.js-view-option');

      // 1. Check LocalStorage and apply
      const saved = localStorage.getItem('collection-layout-pref');
      if (saved === 'list' && container) {
        container.setAttribute('data-view-mode', 'list');
        // Visually check the list radio button if it exists
        const listRadio = document.querySelector('input[value="list"].js-view-option');
        if(listRadio) listRadio.checked = true;
      }

      // 2. Add Listeners to Radio Buttons
      radios.forEach(radio => {
        radio.addEventListener('change', (e) => {
          const val = e.target.value;
          localStorage.setItem('collection-layout-pref', val);
          
          if (val === 'list') {
            container.setAttribute('data-view-mode', 'list');
          } else {
            container.removeAttribute('data-view-mode');
          }
        });
      });
    }

    initViewToggle();

    // 3. Handle AJAX Reloads (Filters)
    // When filters change, Shopify replaces the DOM. We need to re-apply the class.
    const observer = new MutationObserver((mutations) => {
       const container = document.querySelector('.collection-wrapper');
       if(container && localStorage.getItem('collection-layout-pref') === 'list') {
          // If the attribute is missing after reload, add it back
          if(!container.hasAttribute('data-view-mode')){
             container.setAttribute('data-view-mode', 'list');
             
             // Also re-check the radio button
             const listRadio = document.querySelector('input[value="list"].js-view-option');
             if(listRadio) listRadio.checked = true;
          }
       }
    });
    
    // Watch the results-list element for changes
    const wrapper = document.querySelector('results-list');
    if(wrapper) observer.observe(wrapper, { childList: true, subtree: true });
  });

// ═══════════════════════════════════════════════════════════════════
// SSG peptide stack URL handler (?ssg_cart=ID:QTY,...)
// (was inline in layout/theme.liquid)
// ═══════════════════════════════════════════════════════════════════
    (function() {
      var params = new URLSearchParams(window.location.search);
      var items = params.get('ssg_cart');
      if (!items) return;

      // Clean the URL so it doesn't fire again on refresh
      history.replaceState(null, '', window.location.pathname);

      // Parse "VARIANT_ID:QTY,VARIANT_ID:QTY" into AJAX cart format
      var cartItems = items.split(',').map(function(item) {
        var parts = item.split(':');
        return { id: parseInt(parts[0]), quantity: parseInt(parts[1]) || 1 };
      });

      // Clear cart, then add items, then open the drawer
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cartItems })
          });
        })
        .then(function() {
          // Click the cart drawer trigger button
          var cartBtn = document.querySelector('[data-testid="cart-drawer-trigger"]');
          if (cartBtn) {
            setTimeout(function() { cartBtn.click(); }, 300);
          }
        })
        .catch(function(err) {
          console.error('[ssg_cart]', err);
        });
    })();


// ═══════════════════════════════════════════════════════════════════
// SSG PDP — gallery thumbnail switching + quantity stepper + variant sync
// (lives with sections/product-pdp-ssg.liquid)
// ═══════════════════════════════════════════════════════════════════
(() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.pdp-ssg').forEach(initPdpSsg);
  });

  // Also re-init on any AJAX section reload (Shopify sends section:load events)
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('.pdp-ssg').forEach(initPdpSsg);
  });

  function initPdpSsg(root) {
    if (!root || root.dataset.pdpSsgInited) return;
    root.dataset.pdpSsgInited = 'true';

    initGallery(root);
    initQtyStepper(root);
    initVariantSync(root);
  }

  // ─── Gallery: thumbnail clicks toggle the active main image ───
  function initGallery(root) {
    const main = root.querySelector('[data-gallery-main]');
    const thumbs = root.querySelector('[data-gallery-thumbs]');
    if (!main || !thumbs) return;

    thumbs.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-gallery-thumb]');
      if (!btn) return;

      const idx = btn.dataset.galleryThumb;

      thumbs.querySelectorAll('.pdp-ssg__thumb').forEach((t) =>
        t.classList.toggle('is-active', t === btn)
      );
      main.querySelectorAll('.pdp-ssg__gallery-image-wrap').forEach((img) =>
        img.classList.toggle('is-active', img.dataset.galleryImageIndex === idx)
      );
    });
  }

  // ─── Quantity stepper buttons ───
  function initQtyStepper(root) {
    const minus = root.querySelector('[data-pdp-qty-minus]');
    const plus = root.querySelector('[data-pdp-qty-plus]');
    const input = root.querySelector('[data-pdp-qty-input]');
    if (!input) return;

    const clamp = (v) => Math.max(parseInt(input.min || '1', 10), v || 1);

    if (minus) {
      minus.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (plus) {
      plus.addEventListener('click', () => {
        input.value = clamp(parseInt(input.value, 10) + 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  // ─── Variant sync: when an option radio changes, find the matching variant
  // and update the hidden id input (so add-to-cart submits the right variant). ───
  function initVariantSync(root) {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = root.querySelector('[data-pdp-variant-id]');
    if (!form || !idInput) return;

    const variantData = (() => {
      // Grab the product object from the page's __ssgProduct__ window stash if present;
      // otherwise build a minimal lookup from the rendered radio options.
      // For now, we let Shopify's AJAX cart handle invalid combinations gracefully
      // and only update visual selection. Full variant resolution can be added later.
      return null;
    })();

    form.addEventListener('change', (e) => {
      const opt = e.target.closest('[data-pdp-variant-option]');
      if (!opt) return;

      // Visual: mark selected label
      const fieldset = opt.closest('.pdp-ssg__variant-fieldset');
      if (fieldset) {
        fieldset.querySelectorAll('.pdp-ssg__variant-option').forEach((label) =>
          label.classList.toggle('is-selected', label.contains(opt) && opt.checked)
        );
      }

      // Note: full variant ID resolution requires the product JSON. For now we rely
      // on Shopify's storefront accepting `options[Name]=Value` pairs in the form
      // submission via /cart/add — modern Shopify handles this gracefully.
      // If we need precise variant matching client-side, hook in product JSON later.
    });
  }
})();

// ═══════════════════════════════════════════════════════════════════
// Expiration explainer dialog
// Badge markup + dialog live in snippets/b2b-expiration-indicator.liquid;
// the <dialog> is the badge button's next sibling. Delegated so it keeps
// working after AJAX filter/section reloads.
// ═══════════════════════════════════════════════════════════════════
(function() {
  document.addEventListener('click', function(e) {
    var badge = e.target.closest('.b2b-expiration');
    if (badge) {
      var dialog = badge.nextElementSibling;
      if (dialog && dialog.classList && dialog.classList.contains('expiration-explainer')) {
        e.preventDefault();
        dialog.showModal();
      }
      return;
    }

    var closeBtn = e.target.closest('.expiration-explainer__close');
    if (closeBtn) {
      closeBtn.closest('dialog').close();
      return;
    }

    // A click on the ::backdrop (or the dialog's own padding-free frame)
    // reports the <dialog> element itself as the target — treat as dismiss.
    if (e.target.classList && e.target.classList.contains('expiration-explainer')) {
      e.target.close();
    }
  });
})();
